import { Navigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';

const UnProtectedRoute = ({ children }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  return isAuthenticated ? <Navigate to="/dashboard" /> : children;
};

export default UnProtectedRoute;
